import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  dashboard: {},
  period: { amount: 1, unit: 'd' }
}

const getters = {
  dashboard: state => state.dashboard,
  period: state => state.period
}

const mutations = {
  dashboard: (state, dashboard) => {
    state.dashboard = dashboard
  },
  period: (state, period) => {
    state.period = period
  }
}

const actions = {
  async fetchDashboard({ state, commit }) {
    const dashboard = await axios.get(`${config.getRootApi()}/dashboard`, {
      params: state.period
    })
    commit('dashboard', dashboard.data)
  },
  async updateDashboardPeriod({ commit, dispatch }, period) {
    await commit('period', period)
    return dispatch('fetchDashboard')
  },
  async exportUserActivity() {
    return axios({
      method: 'get',
      url: `${config.getRootApi()}/dashboard/activity`,
      responseType: 'blob'
    }).then(function (response) {
      let contentDisposition = response.headers['content-disposition']
      let fileName = contentDisposition ? contentDisposition.split('filename=')[1] : null
      let fileLink = document.createElement('a')
      fileLink.href = window.URL.createObjectURL(new Blob([response.data]))
      fileLink.setAttribute('download', fileName || 'UserActivity.xlsx')
      document.body.appendChild(fileLink)
      fileLink.click()
    })
  },
  async usageStatistics() {
    return axios({
      method: 'get',
      url: `${config.getRootApi()}/dashboard/usagestatistics`,
      responseType: 'blob'
    }).then(function (response) {
      let contentDisposition = response.headers['content-disposition']
      let fileName = contentDisposition ? contentDisposition.split('filename=')[1] : null
      let fileLink = document.createElement('a')
      fileLink.href = window.URL.createObjectURL(new Blob([response.data]))
      fileLink.setAttribute('download', fileName || 'UserActivity.xlsx')
      document.body.appendChild(fileLink)
      fileLink.click()
    })
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
